<!--<app-header></app-header>-->
<app-header-v2></app-header-v2>
<router-outlet></router-outlet>
<canvas id="canvas" [ngClass]="theme"></canvas>
